import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'content-loading-card',
    templateUrl: './content-loading-card.component.html',
    styleUrls: ['./content-loading-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContentLoadingCardComponent {

  constructor() { }

}